import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#ffffff', //"#f0f2f5",
          primary: '#00a892',
          //'on-surface': '#FF0000',
          // "on-surface-variant": '#000',
          'primary-darken-1': '#30958A',
          //"primary": "#99F9EC",
          secondary: '#0B1C3D',
          accent: '#204165',
          'base-bg': '#FAFAFA',
          blue: '#7293CB',
          'navy-blue': '#196B8F',
          'dark-blue': '#303F48',
          anchor: '#00a892'
        }
      },
      dark: {
        dark: true,
        colors: {
          // background: "#ffffff",//"#f0f2f5",
          primary: '#00a892',
          // 'on-surface': '#00FFFF',
          'primary-darken-1': '#30958A',
          //"primary": "#8d9493",
          //  "secondary": "#0B1C3D",
          accent: '#204165',
          'base-bg': '#FAFAFA',
          blue: '#7293CB',
          'navy-blue': '#196B8F',
          'dark-blue': '#303F48',
          anchor: '#00a892'
        }
      }
    }
  }
})
